import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const searchBoolean = z.preprocess((value) => {
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    if (normalized === 'true') return true
    if (normalized === 'false') return false
  }
  return value
}, z.boolean())

const billingSearchSchema = z.object({
  success: searchBoolean.optional(),
  canceled: searchBoolean.optional(),
  autoStartTrial: searchBoolean.optional(),
  billingRequired: searchBoolean.optional(),
  plan: z.enum(['pro', 'business']).optional(),
  interval: z.enum(['monthly', 'yearly']).optional(),
})

export const Route = createFileRoute('/billing')({
  validateSearch: billingSearchSchema,
  beforeLoad: ({ search }) => {
    // Pass success/canceled params to settings page for Stripe callback handling
    throw redirect({
      to: '/settings',
      search: {
        section: 'account',
        billingSuccess: search.success,
        billingCanceled: search.canceled,
        autoStartTrial: search.autoStartTrial,
        billingRequired: search.billingRequired,
        plan: search.plan,
        interval: search.interval,
      },
    })
  },
  component: () => null,
})
